<script setup>
import NotificationMessage from './NotificationMessage.vue';
import EnIcon from 'Components/icons/EnIcon.vue';

import {useI18n} from 'vue-i18n';

const props = defineProps({
  messages: Array,
  canBeClosed: {
    type: Boolean,
    default: true
  }
});
const emit = defineEmits(['message-close']);
const {t} = useI18n();

function handleClose(message) {
  emit('message-close', message);
}
</script>

<template>
  <div class="messages-list">
    <div v-if="messages.length === 0" class="messages-placeholder-wrapper">
      <div class="messages-placeholder d-flex flex-column">
        <div class="ma-auto">
          <en-icon size="150">mdi-party-popper</en-icon>
        </div>
        <div class="placeholder-message-text">{{ t('common.notifications.clear') }}</div>
      </div>
    </div>
    <template v-for="message in messages">
      <notification-message :message="message" :message-close="() => handleClose(message)" :can-be-closed="canBeClosed"></notification-message>
    </template>
  </div>
</template>

<style scoped lang="scss">
.messages-list {
  .notification-message {
    overflow: visible;
    margin: 10px 20px;
  }
}
</style>